/*
 * Copyright (c) 2022-2023. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from "pinia";
import Axios from "@auth/vue-share/utility/axios";

export const useApiKeysStore = defineStore({
  id: "apiKeys",
  state: () => ({
    clients: undefined
  }),
  actions: {
    getApiKeys(client_id) {
      return new Promise((resolve) => {
        Axios.get("api-keys", `/oauth2/api-key/${client_id}`).then((response) => {
          resolve(response.data.data);
        });
      });
    },
    createApiKey(payload) {
      return new Promise((resolve, reject) => {
        Axios.post("api-keys", `/oauth2/api-key`, payload).then((response) => {
          resolve(response.data.data);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    deleteApiKey(client_id, name) {
      return new Promise((resolve, reject) => {
        Axios.delete("api-keys", `/oauth2/api-key/${client_id}/${name}`).then(() => {
          resolve();
        }).catch((err) => {
          reject(err);
        });
      });
    }
  }
});
